<div class="d-flex">
    <span class="mr-auto text-contents">
        <ng-container *ngIf="!(relatedItem$ | async)">
            <ds-loading [showMessage]="false"></ds-loading>
        </ng-container>
        <ng-container *ngIf="(relatedItem$ | async)">
            <ds-listable-object-component-loader [showLabel]="false" [viewMode]="viewType" [object]="(relatedItem$ | async)"></ds-listable-object-component-loader>
        </ng-container>
    </span>
    <button type="button" class="btn btn-secondary"
            title="{{'form.remove' | translate}}"
            (click)="removeSelection()">
        <span class="fas fa-trash" aria-hidden="true"></span>
        <span class="wb-inv">{{'form.remove' | translate}}</span>
    </button>
</div>
